<template>
  <b-row cols="2">
    <b-col cols="9" class="rounded border ml-3 mr-3 p-3 mb-3">
      <div class="brightness-slider">
        <label for="range-1">Adjust Brightness</label>
        <b-form-input id="range-1" v-model="brightnessValue" type="range" min="0" max="5"></b-form-input>
      </div>
      <div class="annotateImageWrapper">
        <img id="annotateImage" v-if="file.signedUrl" :src="file.signedUrl"
             :class="['img-brightness-' + brightnessValue]"/>
      </div>
      <div id="konvaLayer"></div>
    </b-col>
    <b-col class="flex-column justify-content-between rounded border p-3 mr-3 mb-3 right-box">
      <b-row class="flex-column list">
        <b-button
            class="m-1"
            v-for="type in file.annotationTypes"
            :key="type.index"
            :style="{'background-color':type.color, border:'none'}"
            @click="drawAnnotation(type.index, type.color, null)"
        >{{ type.type }}
        </b-button
        >
        <b-col for="range-1">Image Information:</b-col>
        <b-col for="range-1">Image Name: {{ file.fileName }}</b-col>
        <b-col v-if="fileStatus == 'NEEDS_REVIEW'" for="range-1">Annotated By: {{ file.assignedToName }}</b-col>
      </b-row>
      <div class="save-bottom">
        <b-row class="flex-column save-btn list" v-if="fileStatus === 'NEEDS_REVIEW'">
          <!--          <b-button size="lg" class="m-1" variant="primary" :disabled="true">View RGB</b-button>-->
          <b-button size="lg" class="m-1" variant="primary" @click="clearAnnotations()"
          >Clear Annotations
          </b-button
          >
          <b-button size="lg" class="m-1" variant="primary" @click="saveAndNext()"
          >Approve Annotations
          </b-button
          >
          <b-button size="lg" class="m-1" variant="primary" @click="skipAndNext()">Skip</b-button>
        </b-row>
        <b-row
            class="save-btn justify-content-md-center"
            v-if="fileStatus === 'TO_DO'"
        >
          <b-button size="lg" class="m-1" variant="primary" @click="copy()"
          >Copy
          </b-button
          >
          <b-button size="lg" class="m-1" variant="primary" @click="paste()"
          >Paste
          </b-button
          >
          <b-button size="lg" class="m-1" variant="primary" @click="clear()"
          >Clear
          </b-button
          >
        </b-row>
        <b-row class="flex-column list" v-if="fileStatus === 'TO_DO'">
          <b-button size="lg" class="m-1" variant="primary" @click="saveAndNext()"
          >Save & Next
          </b-button
          >
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import Konva from 'konva';

const width = window.innerWidth;
const height = window.innerHeight;
export default {
  name: "Annotate",
  data() {
    return {
      file: {},
      id_token: '',
      serviceUrl: 'https://annotation-service-dot-development-cloud-services.appspot.com/',
      // serviceUrl: 'http://localhost:8080',
      rectConfig: {
        x: 20,
        y: 20,
        width: 200,
        height: 200,
        stroke: 'green',
        strokeWidth: 2,
        draggable: true
      },
      annotations: [],
      brightnessValue: 0,
      edgeWidth: 720,
      edgeHeight: 540
    }
  },
  props: {
    deviceId: String,
    fileStatus: String
  },
  created() {
  },
  async mounted() {
    if (!this.$auth.isAuthenticated) {
      return;
    }
    const claims = await this.$auth.getIdTokenClaims();
    this.id_token = claims.__raw;
    this.stage = new Konva.Stage({
      container: 'konvaLayer',
      width: width,
      height: height
    });
    this.layer = new Konva.Layer();
    this.saveAndNext();
  },
  methods: {
    drawAnnotation(index, color, config) {
      if (!config) {
        config = this.rectConfig;
      }
      if (color) {
        config.stroke = color;
      }
      const rect = new Konva.Rect(config);
      const tr = new Konva.Transformer({
        nodes: [rect],
        ignoreStroke: true,
        keepRatio: false,
      });
      this.layer.add(tr);
      this.layer.add(rect);
      this.stage.add(this.layer);
      rect.type = index;
      rect.on('transformend', () => {
        this.copy();
      });
      rect.on('dragend', () => {
        this.copy();
      });
    },
    copy() {
      this.annotations = [];
      const children = this.layer.getChildren();
      if (children) {
        children.forEach(rect => {
          if (rect.getType() === 'Shape') {
            const x = rect.attrs.x / this.edgeWidth;
            const y = rect.attrs.y / this.edgeHeight;
            const width = (rect.attrs.width * (rect.attrs.scaleX ? rect.attrs.scaleX : 1)) / this.edgeWidth;
            const height = (rect.attrs.height * (rect.attrs.scaleY ? rect.attrs.scaleY : 1)) / this.edgeHeight;
            const centerX = x + (width / 2);
            const centerY = y + (height / 2);
            const annotation = {
              annotationType: rect.type,
              coordinates: [
                parseFloat(centerX.toFixed(6)),
                parseFloat(centerY.toFixed(6)),
                parseFloat(width.toFixed(6)),
                parseFloat(height.toFixed(6))
              ]
            }
            this.annotations.push(annotation);
          }
        });
      }
    },
    fetch_retry(delay, retires, request_option) {
      return new Promise((resolve, reject) => {
        const wait = (delay) => {
          return new Promise((resolve) => {
            setTimeout(resolve, delay * 1000)
          })
        };
        const onError = (err) => {
          let triesLeft = retires - 1;
          if (!triesLeft) {
            throw err;
          }
          return wait(delay).then(() => {
            this.fetch_retry(delay, triesLeft, request_option)
          })
        }
        fetch(request_option)
            .then(result => {
              if (result && result.status === 503) {
                onError('503 request')
              } else {
                resolve(result)
              }
            })
            .catch(err => {
              reject('failed');
            })
      })
    },
    paste() {
      if (this.annotations) {
        this.annotations.forEach((annotation) => {
          const annotationType = this.file.annotationTypes.find(y => y.index === annotation.annotationType);
          const width = annotation.coordinates[2];
          const height = annotation.coordinates[3];
          const x = (annotation.coordinates[0] - (width / 2)) * this.edgeWidth;
          const y = (annotation.coordinates[1] - (height / 2)) * this.edgeHeight;
          const config = {
            x: x,
            y: y,
            width: width * this.edgeWidth,
            height: height * this.edgeHeight,
            stroke: annotationType.color,
            strokeWidth: 2,
            draggable: true
          }
          this.drawAnnotation(annotationType.index, null, config)
        });
      }
    },
    clear() {
      this.layer.destroyChildren();
    },
    async saveAndNext() {
      this.copy();
      let query = '';
      let body = null;
      let uri = '/save-and-next';
      if (this.fileStatus === 'NEEDS_REVIEW') {
        uri = '/review-and-next';
      }
      if (this.file && this.file._id) {
        query = '?id=' + this.file._id;
        body = JSON.stringify({
          "annotations": this.annotations
        });
      }
      const url = this.serviceUrl + `/devices/` + this.deviceId + uri + query;
      let request = new Request(url, {
        method: "POST",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        body: body,
        headers: {
          Authorization: "Bearer " + this.id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        const reponse = await this.fetch_retry(2, 5, request);
        if (reponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (reponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          return;
        }
        this.file = await reponse.json();
        this.clear();
        if (this.file.annotations) {
          this.annotations = this.file.annotations;
          this.paste();
        }
      } catch (e) {
        console.error(e);
      }
    },
    async clearAnnotations() {
      let query = '?id=' + this.file._id;
      let body = JSON.stringify({
        "annotations": []
      });

      const url = this.serviceUrl + `/devices/` + this.deviceId + '/clear-annotations' + query;
      let request = new Request(url, {
        method: "POST",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        body: body,
        headers: {
          Authorization: "Bearer " + this.id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        const reponse = await this.fetch_retry(2, 5, request);
        if (reponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (reponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          return;
        }
        let data = await reponse.json();
        console.log(data)
        this.clear();
      } catch (e) {
        console.error(e);
      }
    },
    async skipAndNext() {
      this.copy();
      let query = '';
      let uri = '/skip-and-next';
      if (this.file && this.file._id) {
        query = '?id=' + this.file._id;
      }
      const url = this.serviceUrl + `/devices/` + this.deviceId + uri + query;
      let request = new Request(url, {
        method: "POST",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + this.id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        const reponse = await this.fetch_retry(2, 5, request);
        if (reponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (reponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          return;
        }
        this.file = await reponse.json();
        this.clear();
        if (this.file.annotations) {
          this.annotations = this.file.annotations;
          this.paste();
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
}
</script>
<style>
.row.flex-column.list {
  margin: 0;
}

.row.flex-column.list .btn {
  text-align: left;
}

.row.flex-column.list .btn-lg {
  text-align: center;
}

.annotateImageWrapper {
  background: #000;
}

.right-box {
  display: flex;
}

#annotateImage {
  width: auto;
  height: calc(100vh - 300px);
  display: block;
  margin: 0 auto;
}

.save-btn {
  margin-top: 160px;
}

.save-btn button.btn.m-1.btn-primary.btn-lg {
  height: 40px;
  padding: 0 15px;
}

#konvaLayer {
  width: 100% !important;
  height: calc(100vh - 300px);
  position: absolute;
  top: 76px;
  left: 15px;
}

.konvajs-content {
  width: 100% !important;
  height: calc(100vh - 300px) !important;
}

.brightness-slider {
  z-index: 9999;
  position: relative;
  width: 100%;
  color: #6a6a6a;
}

.img-brightness-1 {
  filter: brightness(120%)
}

.img-brightness-2 {
  filter: brightness(240%)
}

.img-brightness-3 {
  filter: brightness(340%)
}

.img-brightness-4 {
  filter: brightness(440%)
}

.img-brightness-5 {
  filter: brightness(540%)
}
</style>
